export function isApiSuccess(resp) {
  const d = resp?.data;

  if (resp?.status === 200) return true;

  if (d?.success === true) return true;

  if (typeof d?.status === "string") {
    const s = d.status.toLowerCase();
    if (s === "ok" || s === "success") return true;
  }
  if (typeof d?.status === "number" && d.status === 200) return true;

  if (d?.code === 0 || d?.code === 200) return true;

  if (d?.data?.result?.url) return true;

  return false;
}

export function navigateSameTab(url) {
  if (!url) return;
  window.location.href = url;
}
